// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__1NxrO","boxTitle":"Qualiphy_boxTitle__sltyO","box":"Qualiphy_box__19suY","toggleWrap":"Qualiphy_toggleWrap__2XCBM"};